/**
 * 中英文站旧展会列表 URL：404 守卫 → 301 语义 pathname（客户端导航兜底）。
 * 服务端首屏：server/middleware/00-fairListLegacyGuardAndRedirect.ts。
 */
import { getLanguageByHost } from '~/utils/language-detection'

function legacySearchFromRouteQuery(query: Record<string, unknown>): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(query)) {
    if (v == null) continue
    if (Array.isArray(v)) v.forEach(item => qs.append(k, String(item)))
    else qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ''
}

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  let host = ''
  if (typeof window !== 'undefined') {
    host = window.location.host
  }
  const siteLang = getLanguageByHost(host.split(':')[0])
  if (siteLang !== 'cn' && siteLang !== 'en') return

  const search = legacySearchFromRouteQuery(to.query as Record<string, unknown>)
  const { resolveLegacyFairListRedirectLocation } = await import('~/utils/fairListLegacyRedirect')
  const location = await resolveLegacyFairListRedirectLocation(to.path, search, to.hash || '')
  if (!location) return
  const current = `${to.path}${search}${to.hash || ''}`
  if (location === current) return
  return navigateTo(location, { redirectCode: 301, external: true })
})
